"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useIconStore", {
  enumerable: true,
  get: function get() {
    return _LocalizationStore.useIconStore;
  }
});
Object.defineProperty(exports, "useLocalizationStore", {
  enumerable: true,
  get: function get() {
    return _LocalizationStore.useLocalizationStore;
  }
});
Object.defineProperty(exports, "useMergeProps", {
  enumerable: true,
  get: function get() {
    return _LocalizationStore.useMergeProps;
  }
});
Object.defineProperty(exports, "useOptionStore", {
  enumerable: true,
  get: function get() {
    return _LocalizationStore.useOptionStore;
  }
});
var _LocalizationStore = require("./LocalizationStore");